import { type Newsletter } from '@@api/services/newsletter/schemas';

export const deserializeNewsletter = (value: Newsletter) => ({
    ...value,
    categoryIds: value.categoryIds?.length ? value.categoryIds : null,
});
